import axios from 'axios'
import history from '../history'
import {SEARCH_TOKEN} from 'redux/constants/Auth'
import {notification} from 'antd';
import EstService from 'services/EstService';

const ENTRY_ROUTE = '/auth/login'

const service = axios.create({
    baseURL: `https://${process.env.REACT_APP_ALGOLIA_APPLICATION_ID}-dsn.algolia.net/1/`,
    timeout: 60000
})

// API Request interceptor
service.interceptors.request.use(config => {
    const searchToken = localStorage.getItem(SEARCH_TOKEN)

    if (searchToken) {
        config.headers['X-Algolia-API-Key'] = searchToken
        config.headers['X-Algolia-Application-Id'] = process.env.REACT_APP_ALGOLIA_APPLICATION_ID
    }

    if (!searchToken) {
        history.push(ENTRY_ROUTE)
        window.location.reload();
    }

    return config
}, error => {
    // Do something with request error here
    notification.error({
        message: 'Error'
    })
    Promise.reject(error)
});

service.interceptors.response.use(response => {
    return response;
}, async (error) => {
    // validUntil parameter has expired
    if (error.response && error.response.status === 400) {
        try {
            const res = await EstService.updateSearchToken();
            localStorage.setItem(SEARCH_TOKEN, res.data.search_token);
            window.location.reload();
        }
        catch(err) {
            Promise.reject(err);
        }
    }
    // Search token is invalid, should be refreshed and retried
    else if (error.response && error.response.status === 403) {
        const res = await EstService.updateSearchToken();
        localStorage.setItem(SEARCH_TOKEN, res.data.search_token);
        window.location.reload();
    }
});

export default service